export default __webpack_public_path__ + "static/media/Maduro-2Open.88725da5.jpg";